/**
 *
 * ListSubdivisions
 *
 */

import React, { Component } from "react"
import { List } from "antd"
import { truncate } from "lodash"
import "./index.less"
import { MinusCircleFilled } from "@ant-design/icons"

class ListSubdivisions extends Component {
  render() {
    return (
      <div className="scrollContent">
        <List
          className="listSubdivisions"
          size="small"
          loading={this.props.loading}
          bordered
          dataSource={this.props.data}
          label={this.props.label}
          renderItem={(item) => {
            return (
              <List.Item>
                <span>{truncate(item[this.props.label], { length: 72 })}</span>
                <MinusCircleFilled
                  style={{ color: "#F07F7F" }}
                  onClick={() => this.props.onRemove(item)}
                />
              </List.Item>
            )
          }}
        />
      </div>
    )
  }
}

ListSubdivisions.defaultProps = { label: "name" }
ListSubdivisions.propTypes = {}

export default ListSubdivisions
